import { AfterViewInit, Component } from '@angular/core';
import { SwiperInitService } from 'src/app/shared/swiper-init.service';

@Component({
  selector: 'app-brand-slider',
  templateUrl: './brand-slider.component.html',
  styleUrl: './brand-slider.component.scss'
})
export class BrandSliderComponent implements AfterViewInit {
  constructor(private swiperInitService: SwiperInitService) { }
  ngAfterViewInit(): void {
    this.swiperInitService.initSliders();
  }
}
